export const namespace = 'ws'
